import { getAccountId, getSeekId } from '@seek/adv-account-selection';
import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { actionUpdateAdvertiserId } from 'src/app/state/modules/session/advertiserId';
import { actionUpdateSeekAdvertiserId as actionUpdateSessionSeekAdvertiserId } from 'src/app/state/modules/session/seekAdvertiserId';
import { actionUpdateSeekAdvertiserId as actionUpdateTealiumSeekAdvertiserId } from 'src/app/state/modules/tealium/seekAdvertiserId';
import { log, setUser } from 'src/app/utils/logging';
import { useLocalisedRoutes } from 'src/app/views/hooks/useLocalisedRoutes';
import type AppState from 'src/types/appState';

export const useAdvertiserId = () => {
  const {
    advertiserId,
    isDataCleanupComplete,
    queryParamsAdvertiserId,
    seekAdvertiserId,
  } = useSelector(
    (state: AppState) => ({
      advertiserId: state.session.advertiserId,
      seekAdvertiserId: state.session.seekAdvertiserId,
      isDataCleanupComplete: state.app.isDataCleanupComplete,
      queryParamsAdvertiserId: state.app.queryParams.advertiserid,
    }),
    shallowEqual,
  );
  const dispatch = useDispatch();
  const accountId = getAccountId();
  const seekId = getSeekId();
  const { redirectToDashboard } = useLocalisedRoutes();
  useEffect(() => {
    if (
      !accountId &&
      !advertiserId &&
      !queryParamsAdvertiserId &&
      !seekAdvertiserId &&
      !seekId
    ) {
      log.error('useAdvertiserId | advertiser id missing', {
        accountId,
        advertiserId,
        isDataCleanupComplete,
        queryParamsAdvertiserId,
        seekAdvertiserId,
        seekId,
      });
      return redirectToDashboard();
    }

    // @NOTE: We use query param as precendent if it is set, otherwise fallback to the account chosen
    const newAdvertiserId: string | undefined =
      queryParamsAdvertiserId || accountId;

    if (isDataCleanupComplete) {
      if (newAdvertiserId && !advertiserId) {
        dispatch(actionUpdateAdvertiserId(newAdvertiserId));
      }

      if (seekId && !seekAdvertiserId) {
        dispatch(actionUpdateSessionSeekAdvertiserId(String(seekId)));
        dispatch(actionUpdateTealiumSeekAdvertiserId(String(seekId)));
        setUser(String(seekId));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    accountId,
    advertiserId,
    isDataCleanupComplete,
    queryParamsAdvertiserId,
    seekAdvertiserId,
    seekId,
  ]);
};
